module.exports = __webpack_public_path__ + "static/orc_feywild_caretaker-5f5706ca497278d66c33de184efafcf3.webp";